import Box from '@mui/material/Box'
import { FC, ReactNode } from 'react'

import ColoredChip from '@/components/AnimatedTransactions/ColoredChip'

const FloatingChip: FC<{
    children: ReactNode
    text: ReactNode
    animationDelay: string
}> = ({ children, text, animationDelay }) => {
    return (
        <Box
            sx={{
                position: 'relative',
            }}
        >
            {children}
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    zIndex: 9,
                    opacity: 0,
                    animation: 'pop-up .3s linear forwards',
                    animationDelay,

                    '@keyframes pop-up': {
                        '0%': {
                            left: '50%',
                            opacity: 0,
                        },
                        '50%': {
                            left: '110%',
                            opacity: 1,
                        },
                        '90%': {
                            left: '114%',
                            opacity: 1,
                        },
                        '100%': {
                            left: '110%',
                            opacity: 1,
                        },
                    },
                }}
            >
                <ColoredChip version={'dark-green'}>{text}</ColoredChip>
            </Box>
        </Box>
    )
}

export default FloatingChip
